import React from 'react'

/**
 * Horizontal section jump links for long resource pages.
 */
const SectionNav = ({ sections, label }) => (
  <nav
    className="mb-10 -mx-4 sm:mx-0"
    aria-label={label}
  >
    <ul className="flex gap-2 overflow-x-auto px-4 sm:px-0 pb-1 scrollbar-thin">
      {sections.map(({ id, label: sectionLabel }) => (
        <li key={id} className="shrink-0">
          <a
            href={`#${id}`}
            className="inline-flex items-center rounded-full border border-primary-darkGreen/20 bg-white px-4 py-2 text-sm font-medium text-primary-darkGreen whitespace-nowrap transition-colors hover:bg-primary-darkGreen hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-darkGreen"
          >
            {sectionLabel}
          </a>
        </li>
      ))}
    </ul>
  </nav>
)

export default SectionNav
